import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateSharedInfo = async (obj) => {
  const sharedInfoRef = doc(firestore, "sharedInfo", "oVT4rke63kzhK4mySCcI");
  await updateDoc(sharedInfoRef, obj);
};

export default updateSharedInfo;